import { render, staticRenderFns } from "./imagetag.vue?vue&type=template&id=066800ef"
import script from "./imagetag.vue?vue&type=script&lang=js"
export * from "./imagetag.vue?vue&type=script&lang=js"
import style0 from "./imagetag.vue?vue&type=style&index=0&id=066800ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports